import { inject } from '@angular/core';
import {
  CanActivateChildFn,
  CanActivateFn,
  CanMatchFn,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { tap } from 'rxjs/operators';
import { AuthService, LogoutReason } from '@shared/helpers/auth.service';
import { RerdirectService } from '@shared/helpers/redirect.service';

const getCanMatchUrl = (segments: UrlSegment[]): string => {
  const base = `/${segments.map((segment) => segment.path).join('/')}`;
  return (base === '/' ? '' : base) + location.search + location.hash;
};

const handleInvalidSession = (
  auth: AuthService,
  redirect: RerdirectService,
  requestedUrl: string,
): void => {
  redirect.saveReturnUrl(requestedUrl || location.pathname + location.search + location.hash);
  auth.logout(false, true, {
    reason: LogoutReason.LocalTab,
    broadcast: false,
    preserveSavedReturnUrl: true,
  });
};

export const AuthCanActivateGuard: CanActivateFn = (_, state: RouterStateSnapshot) => {
  const auth = inject(AuthService);
  const redirect = inject(RerdirectService);

  return auth.validate().pipe(
    tap((valid) => {
      if (!valid) {
        handleInvalidSession(auth, redirect, state.url);
      }
    }),
  );
};

export const AuthCanActivateChildGuard: CanActivateChildFn = (_, state: RouterStateSnapshot) => {
  const auth = inject(AuthService);
  const redirect = inject(RerdirectService);

  return auth.validate().pipe(
    tap((valid) => {
      if (!valid) {
        handleInvalidSession(auth, redirect, state.url);
      }
    }),
  );
};

export const AuthCanMatchGuard: CanMatchFn = (_, segments) => {
  const auth = inject(AuthService);
  const redirect = inject(RerdirectService);
  const url = getCanMatchUrl(segments);

  return auth.validate().pipe(
    tap((valid) => {
      if (!valid) {
        handleInvalidSession(auth, redirect, url);
      }
    }),
  );
};
